<div *ngIf="showBanner" class="cookie-banner">
    <div class="container">
        <div class="cookie-banner-content">
            <div class="cookie-banner-text">
                <p class="mb-0">
                    {{ "Cookie banner message" | translate }}
                    <a routerLink="/cookies" class="cookie-link">{{ "Cookies" | translate }}</a
                    >.
                </p>
            </div>
            <div class="cookie-banner-actions">
                <button type="button" class="btn btn-outline-secondary btn-sm me-2" (click)="rejectCookies()">
                    {{ "Reject cookies" | translate }}
                </button>
                <button type="button" class="btn btn-primary btn-sm" (click)="acceptCookies()">
                    {{ "Accept cookies" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
